<template>
    <div class="buy-window" v-show="isShow">
        <van-overlay :show="isShow" :z-index="101" @click="isShow = false">
            <div class="buy-container" @click.stop>
                <div class="close-icon" @click="isShow = false"></div>
                <div class="product-info">
                    <div class="product-name">
                        <template v-if="Array.isArray(productInfo.labelList)">
                            <span
                                class="lable-item"
                                :key="index"
                                :style="{
                                    backgroundColor: item.backgroundColor,
                                    color: item.fontColor,
                                }"
                                v-for="(item, index) in productInfo.labelList"
                                >{{ item.labelName }}</span
                            >
                        </template>
                        <span>{{ productInfo.goodsName }}</span>
                    </div>
                    <div class="product-params">
                        <div class="product-params">
                            <div class="params-item">
                                <span class="params-name">原厂编码</span>
                                <span class="params-value">{{
                                    productInfo.factoryCode
                                }}</span>
                            </div>
                            <div class="params-item">
                                <span class="params-name">品牌</span>
                                <span class="params-value">{{
                                    productInfo.brand.brandName
                                }}</span>
                            </div>
                            <div class="params-item">
                                <span class="params-name">库存</span>
                                <span class="params-value"
                                    >{{
                                        productInfo.stock.qtyTotal
                                    }}&nbsp;pcs</span
                                >
                            </div>
                            <div class="params-item">
                                <span class="params-name">包装</span>
                                <span class="params-value"
                                    >每{{
                                        productInfo.packingUnitOuter
                                    }}&nbsp;{{
                                        productInfo.packingQty
                                    }}&nbsp;pcs</span
                                >
                            </div>
                            <div class="params-item" v-if="hasBatch">
                                <span class="params-name">批次</span>
                                <span class="params-value">{{
                                    productInfo.stock.batchList[0].batchNo
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="product-price">
                        <div class="caption">
                            <span>含税单价({{ $config.TAX_NUMBER }}%)</span>
                        </div>
                        <ul class="info-ul">
                            <li
                                class="info-item"
                                v-for="(item,
                                index) in productInfo.priceRangeList"
                                :key="index"
                            >
                                <span
                                    class="info-name"
                                    :class="{
                                        active: index == priceActiveIndex,
                                    }"
                                    >{{ item.qtyStart }}+</span
                                >
                                <span class="info-params"
                                    >￥{{ item.price }}</span
                                >
                            </li>
                        </ul>
                    </div>
                    <div class="pcs-form">
                        <div class="caption">
                            <span>数量</span>
                        </div>
                        <div class="input-box">
                            <input
                                type="text"
                                maxlength="8"
                                @blur="pcsChange"
                                @focus="pcsInputFocus"
                                v-model="currentPcs"
                                class="pcs-input"
                            />
                            <div
                                class="prompt_message"
                                v-show="
                                    packingPromptMessageShow &&
                                        currentPcsInputFocus
                                "
                            >
                                <span>金额大于整盘价,购买整盘更划算!</span>
                            </div>
                        </div>
                        <div class="datas-box">
                            <div class="datas-item">
                                <span
                                    >最低起购
                                    {{ productInfo.minPurchase }}
                                    &nbsp;pcs</span
                                >
                            </div>
                            <div class="datas-item t-center">
                                <span
                                    >单价
                                    <em class="text-color font-weight"
                                        >￥{{ currentPrice }}</em
                                    ></span
                                >
                            </div>
                            <div class="datas-item t-center">
                                <span
                                    >总价
                                    <em class="font-weight"
                                        >￥{{ amount | roundFloatPrice(2) }}</em
                                    ></span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btns-box">
                    <div class="btn-item now-btn" @click="buy(cartBuy)">
                        <span>立即购买</span>
                    </div>
                    <div class="btn-item join-btn" @click="buy(cartJoin)">
                        <span>加入购物车</span>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import { cart_join, cart_buy, cart_create } from "@/helper/types/cart";
import { isPositiveNumber } from "@/utils/validation";
const DEFAULT_PRODUCE_INFO = {
    goodsName: "贴片电阻",
    factoryCode: "RR1608(0603)L0R0JT",
    packingUnitOuter: "盘",
    packingQty: 5000,
    priceRangeList: [],
    minPurchase: 50,
    brand: {
        brandName: "美隆",
    },
    stock: {
        qtyTotal: 0,
        batchList: [],
    },
};
import Vue from "vue";
import { Overlay, Notify } from "vant";
import utils from "@/utils/utils";
import { isEmpty } from "@/utils/validation";
Vue.use(Overlay).use(Notify);
export default {
    name: "BuyWindow",
    data() {
        return {
            isShow: false,
            packingPromptMessageShow: false,
            currentPcsInputFocus: false,
            productInfo: DEFAULT_PRODUCE_INFO,
            currentPrice: 0,
            currentPcs: 0,
            amount: 0,
            cartOperation: cart_create,
            cartJoin: cart_join,
            cartBuy: cart_buy,
            priceActiveIndex: -1,
        };
    },
    methods: {
        /**
         * @description 打开购买窗口
         */
        open(productInfo, cartOperation) {
            if (!productInfo) return;
            let { priceRangeList, minPurchase } = productInfo;
            let currentPrice = utils.getPriceRange(priceRangeList, minPurchase);
            let amount = utils.calc.Mul(currentPrice, minPurchase);
            this.cartOperation = cartOperation;
            this.productInfo = productInfo;
            this.currentPcs = minPurchase;
            this.currentPrice = currentPrice;
            this.amount = amount;
            this.isShow = true;
        },
        pcsInputFocus() {
            this.checkPackingPromptMessageShow(this.currentPrice);
            this.currentPcsInputFocus = true;
        },
        /**
         * @description pcs改变
         */
        pcsChange() {
            let pcs = 0;
            let amount = 0;
            let currentPrice = 0;
            let correctedData;
            let {
                minPurchase,
                stock,
                priceRangeList,
                multiplicity,
            } = this.productInfo;
            let currentPcs = this.currentPcs;
            this.currentPcsInputFocus = false;
            if (!isPositiveNumber(currentPcs)) {
                this.currentPcs = pcs = minPurchase;
            } else {
                if (currentPcs < minPurchase) {
                    this.currentPcs = pcs = minPurchase;
                    this.$notify({
                        message: `购买数量需不满足最小起购数,已为您自动修正为${minPurchase}pcs。`,
                        color: "#fff",
                        background: "#4BC227",
                    });
                } else if (currentPcs >= minPurchase) {
                    if (currentPcs > stock.qtyTotal) {
                        let multiple = Math.floor(
                            stock.qtyTotal / multiplicity
                        );
                        pcs = utils.calc.Mul(multiple, multiplicity);
                        this.$notify({
                            message: `购买数不能超过库存,已为您自动修正为${pcs}pcs。`,
                            color: "#fff",
                            background: "#4BC227",
                        });
                    } else {
                        correctedData = utils.correctedPcs(
                            currentPcs,
                            multiplicity,
                            stock.qtyTotal
                        );
                        pcs = correctedData.pcs;
                        if (correctedData.isCorrecte) {
                            this.$notify({
                                message: `${multiplicity}pcs叠加购买,已为您自动修正为${pcs}pcs。`,
                                color: "#fff",
                                background: "#4BC227",
                            });
                        }
                    }
                }
            }
            currentPrice = utils.getPriceRange(priceRangeList, pcs);
            amount = utils.calc.Mul(currentPrice, pcs);
            this.currentPrice = currentPrice;
            this.amount = amount;
            this.currentPcs = pcs;
        },
        /**
         * @description 购买事件
         */
        buy(eventType) {
            if (!eventType) return;
            this.$emit("buy", {
                eventType: eventType,
                pcs: this.currentPcs,
                productId: this.productInfo.productId,
                cartOperation: this.cartOperation,
            });
            this.isShow = false;
        },
        checkPackingPromptMessageShow(pcs) {
            if (isEmpty(pcs)) {
                pcs = 0;
            }
            let {
                priceRangeList,
                minPurchase = 0,
                packingQty = 0,
            } = this.productInfo;
            if (isEmpty(priceRangeList)) return;
            let currentPrice = utils.calc.Mul(
                pcs,
                utils.getPriceRange(priceRangeList, pcs)
            );
            let packingPrice = utils.calc.Mul(
                packingQty,
                utils.getPriceRange(priceRangeList, packingQty)
            );
            let packingPromptMessageShow =
                pcs >= minPurchase &&
                pcs < packingQty &&
                pcs >= packingPrice &&
                currentPrice >= packingPrice;
            this.packingPromptMessageShow = packingPromptMessageShow;
        },
        updatePcsAmount(pcs) {
            let { priceRangeList } = this.productInfo;
            if (isEmpty(priceRangeList)) {
                this.amount = 0;
                return;
            }
            let currentPrice = utils.getPriceRange(priceRangeList, pcs);
            let amount = utils.calc.Mul(currentPrice, pcs);
            this.amount = amount;
        },
    },
    computed: {
        /**
         * @description 计算是否不能购买
         */
        unableBuy() {
            return (
                this.productInfo.stock.qtyTotal < this.productInfo.minPurchase
            );
        },
        //是否有批次
        hasBatch() {
            let { batchList = [] } = this.productInfo.stock;
            return !isEmpty(batchList);
        },
    },
    watch: {
        currentPcs: {
            handler: function(pcs = 0, oldPcs = 0) {
                let { priceRangeList } = this.productInfo;
                let currentPrice = utils.getPriceRange(priceRangeList, pcs);
                let priceActiveIndex = utils.getRangePriceIndex(
                    priceRangeList,
                    currentPrice
                );
                this.priceActiveIndex = priceActiveIndex;
                this.checkPackingPromptMessageShow(pcs);
                this.updatePcsAmount(pcs);
            },
            immediate: true,
        },
    },
};
</script>
<style lang="less" scoped>
.buy-window {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    .buy-container {
        position: absolute;
        z-index: 10;
        width: 750px;
        left: 50%;
        margin-left: -375px;
        bottom: 0px;
        background-color: #fff;
        .close-icon {
            position: absolute;
            z-index: 20;
            right: 20px;
            top: 20px;
            width: 40px;
            height: 40px;
            background-image: url("../../../public/images/product/buy-window-close-icon.png");
            background-size: 40px;
            background-repeat: no-repeat;
        }
        .product-info {
            padding: 20px 15px;
        }
        .product-name {
            margin-bottom: 5px;
            padding-right: 50px;
            font-size: 28px;
            line-height: 32px;
            font-weight: 500;
            color: #333;
            word-break: break-all;
            .lable-item {
                margin-right: 5px;
                *display: inline;
                display: inline-block;
                zoom: 1;
                padding: 0 15px;
                font-size: 24px;
                height: 32px;
                line-height: 32px;
            }
        }
        .product-params {
            .params-item {
                font-size: 24px;
                line-height: 1.7;
                .params-name {
                    color: #999;
                    padding-right: 20px;
                }
                .params-value {
                    color: #333;
                }
            }
        }
        .product-price {
            margin-bottom: 15px;
            .caption {
                margin: 25px 0 15px;
                font-size: 24px;
                color: #333;
            }
            .info-ul {
                font-size: 0px;
                > .info-item {
                    text-align: left;
                    margin-bottom: 5px;
                    .info-name {
                        vertical-align: top;
                        *display: inline;
                        display: inline-block;
                        zoom: 1;
                        min-width: 110px;
                        padding-right: 40px;
                        font-size: 24px;
                        line-height: 34px;
                        color: #999;
                        &.active {
                            color: #f50;
                        }
                    }
                    .info-params {
                        vertical-align: top;
                        *display: inline;
                        display: inline-block;
                        zoom: 1;
                        font-size: 24px;
                        line-height: 34px;
                        color: #f50;
                    }
                }
            }
        }
        .pcs-form {
            .caption {
                font-size: 24px;
                color: #333;
            }
            .input-box {
                position: relative;
                z-index: 0;
                margin-top: 15px;
                width: 280px;
                height: 60px;
                border: 1px #dedede solid;
                .pcs-input {
                    padding-left: 20px;
                    width: 260px;
                    height: 60px;
                    border: none;
                    font-size: 28px;
                    color: #333;
                }
                .prompt_message {
                    position: absolute;
                    z-index: 1;
                    top: 0px;
                    left: 300px;
                    width: 450px;
                    height: 60px;
                    border: none;
                    font-size: 24px;
                    line-height: 60px;
                    color: #e29b00;
                }
            }
            .datas-box {
                margin-top: 10px;
                height: 40px;
                line-height: 40px;
                font-size: 24px;
                .datas-item {
                    float: left;
                    width: 33.3%;
                    height: 40px;
                    line-height: 40px;
                    .font-weight {
                        font-weight: 500;
                    }
                    &.t-center {
                        text-align: center;
                    }
                    em {
                        color: #ff5500;
                    }
                }
            }
        }
        .btns-box {
            height: 100px;
            .btn-item {
                float: left;
                width: 50%;
                height: 100px;
                font-size: 32px;
                line-height: 100px;
                text-align: center;
                &.now-btn {
                    background-color: #e0fed7;
                    color: #4bc227;
                }
                &.join-btn {
                    background-color: #4bc227;
                    color: #fff;
                }
            }
        }
    }
}
</style>
